











































































































































































import { Component, Vue } from 'vue-property-decorator';
import { PublicRIDCContractorDTO } from "@/dto/request/ridc/PublicRIDCContractorDTO";
import { namespace } from "vuex-class";
import RIDCService from "@/services/request/RIDCService";
import { ResidencyStatus } from "@/constants/PersonConstants";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import { RIDCContractorStatus } from "@/constants/request/RIDCConstants";
import { processError } from "@/utils/ComponentUtils";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";

const AppModule = namespace("App");

@Component({
  components: {
    SingleFileHolder,
    PortalCheckbox,
  },
  computed: {
    RIDCContractorStatus() {
      return RIDCContractorStatus
    },
    ResidencyStatus() {
      return ResidencyStatus
    }
  }
})
export default class PublicContractorRIDC extends Vue {

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  request: PublicRIDCContractorDTO | null = null;
  residencyStatusIsDefined = false;
  addressIsDifferent = false;

  mounted(): void {
    this.loadRequest();
  }

  loadRequest(): void {
    this.startLoading();
    RIDCService.getContractorByPublicId(this.id).then(
      ok => {
        this.request = ok.data;
        this.residencyStatusIsDefined = !!ok.data.residencyStatus;
        this.stopLoading();
      },
      err => {
        this.stopLoading();
        processError(err, this);
      }
    )
  }

  save(): void {
    if(!this.request) {
      return;
    }
    this.startLoading();
    RIDCService.saveContractorByPublicId(this.id, this.request).then(
      ok => {
        this.stopLoading();
        this.loadRequest();
      },
      err => {
        this.stopLoading();
        processError(err, this);
      }
    )
  }

  saveWithoutStateIdBack(): void {
    this.request!.saveWithoutStateIdBack = true;
    this.save();
  }

  get id(): string {
    return this.$route.params.id;
  }

  get isFilledMandatoryDocuments(): boolean {
    return this.isFilledFederalDocument
      && this.isFilledSSN
      && this.isFilledStateID
      && this.isFilledBankDetails;
  }

  get isFilledFederalDocument(): boolean {
    switch (this.request?.residencyStatus) {
      case ResidencyStatus.CITIZEN:
        return true;
      case ResidencyStatus.PERMANENT_RESIDENT:
        return (!this.request.greenCardRequired || !!(this.request?.greenCardFrontImage && this.request?.greenCardBackImage));
      case ResidencyStatus.NON_CITIZEN:
        return (!this.request.eadRequired || !!(this.request?.eadFrontImage && this.request?.eadBackImage))
      default:
        return false;
    }
  }

  get isFilledSSN(): boolean {
    return !this.request?.ssnRequired || !!this.request.ssnImage;
  }

  get isFilledStateID(): boolean {
    return !!this.request && (!this.request.stateIdRequired || (this.request.latestStateIdState
      && this.request?.stateIdIsValid) || !!this.request.stateIdFrontImage  || !!this.request.foreignPassportTitleImage);
  }

  get isFilledBankDetails(): boolean {
    return !!this.request && (!this.request.bankDetailsRequired || (this.request.currentAccountBank &&
      this.request.currentAccountIsValid) || !!this.request.voidCheckImage);
  }

  get isBankAccountPresent(): boolean {
    return !!this.request?.currentAccountBank && this.request?.currentAccountBank != '';
  }
}
